import { IconDefinition } from '@fortawesome/pro-solid-svg-icons';
import { ReactNode } from 'react';

export interface ILevel1MenuItem {
    name?: any
    imagePath?: string;
    faIcon?: IconDefinition;
    svgIcon?: ReactNode;
    link?: string;
    orgUrlName?: string;
    orgId?: string;
    fullMenu?: boolean;
    className?: string;
    onClick?(...args: unknown[]);
}

export enum EMenuItem {
    home = 'home',
    new = 'new',
    filter = 'filter',
    people = 'people',
    entities = 'entities',
    administration = 'administration',
    messaging = 'messaging',
    notifications = 'notifications',
    privacy = 'privacy',
    settings = 'settings',
    billing = 'billing',
    profile = 'profile',
    network = 'network',
    invite = 'invite',
    search = 'search',
    companies = 'companies',
    dashboard = 'dashboard',
    norms = 'norms',
    searchInNorms = 'searchInNorms',
    normsManagement = 'normsManagement',
    panel = 'panel',
    myrequests = 'myrequests',
    explore = 'explore',
    entitiesDashboard = 'entitiesDashboard',
    participationDashboard = 'participationDashboard',
    chart = 'chart',
    mandateDashboard = 'mandateDashboard',
    workspaceUsers = 'workspaceUsers',
    signature = 'signature',
    keyDate = 'keyDate',
    approval = 'approval',
    POA = 'POA',
    poaDashboard = 'poaDashboard',
    coiDashboard = 'coiDashboard',
    sponsoringDashboard = 'sponsoringDashboard',
    campaignDashboard = 'campaignDashboard',
    request = 'request',
    KnowledgeManagement = 'KnowledgeManagement',
    publications = 'publications',
    projectDashboard = 'projectDashboard',
    actionsDashboard = 'actionsDashboard',
    LPA = 'LPA',
    FAQ = 'FAQ',
    SideLetter = 'SideLetter',
    Clausier = 'Clausier',
    ClausierPOA = 'ClausierPOA',
    AllQNA = 'AllQNA',
    AllRights = 'allRights',
    CompositeSideLetter = 'compositeSideLetter',
    AllFAQ = 'AllFAQ',
    Tracker = 'Tracker',
    landLordDashboard= 'landLordDashboard',
    landlordLeaseDashboard = 'landlordLease',
    landlordLotDashboard = 'landlordLot',
    landlordOccupantDashboard = 'landlordOccupant',
    landlordOwnerDashboard = 'landlordOwner',
    instancesDashboard = 'instancesDashboard',
    tradeAssociationDashboard = 'tradeAssociationDashboard',
    inquiriesDashboard = 'inquiriesDashboard',
    inquiriesDetails = 'inquiriesDetails',
    tprmEntitiesDashboard = 'tprmEntitiesDashboard',
    tprmReviewsDashboard = 'tprmReviewsDashboard',
    approvals = 'approvals',
    approvalInsights = 'approvalInsights',
    userApprovals = 'userApprovals',
    userKeyDates = 'userKeyDates',
    dates = 'dates',
    CLUSTER = 'CLUSTER',
    DISPUTE = 'DISPUTE',
    DISPUTE_INSTANCE = 'DISPUTE_INSTANCE',
    giftActiveDashboard = 'giftActiveDashboard',
    giftArchivedDashboard = 'giftArchivedDashboard',
    eApprovalFreeDeclaration = 'eApprovalFreeDeclaration',
    eApprovalEventExpenses = 'eApprovalEventExpenses',
    eApprovalGrouping = 'eApprovalGrouping',
    eApprovalSponsoring = 'eApprovalSponsoring'
}
